import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { resilienceApi, type ReplicationTask } from '../../api/resilience';

export function ReplicationMonitorPage() {
  const [tasks, setTasks] = useState<ReplicationTask[]>([]);
  useEffect(() => { void resilienceApi.listReplication().then(setTasks); }, []);
  return (
    <div className="mx-auto max-w-6xl p-6">
      <h1 className="text-2xl font-semibold dark:text-slate-100">Replication Monitor</h1>
      <Link to="/resilience" className="mt-2 inline-block text-sm text-emerald-700 hover:underline dark:text-emerald-400">← Resilience Hub</Link>
      <div className="mt-6 grid gap-4 sm:grid-cols-2">{tasks.map((t) => (
        <div key={t.id} className="rounded-xl border p-4 dark:border-slate-700 dark:bg-slate-900">
          <p className="font-medium capitalize">{t.resource_type.replace(/_/g, ' ')}</p>
          <p className="text-sm text-slate-500">{t.source_region} → {t.target_region}</p>
          <p className="mt-2 text-sm"><span className={t.status === 'synced' ? 'text-green-600' : 'text-amber-600'}>{t.status}</span> · lag {t.lag_seconds}s</p>
        </div>
      ))}</div>
    </div>
  );
}
